var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 48,
    viewBox: "0 0 42 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7190_11523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 3.3938V5.07005C30.7969 6.14911 36 12.0375 36 19.1438V22.275C36 26.5313 37.4531 30.6657 40.1063 33.9938L41.5031 35.7375C42.0469 36.4125 42.15 37.3407 41.775 38.1188C41.4 38.8969 40.6125 39.3938 39.75 39.3938H2.25002C1.3847 39.3938 0.596736 38.8969 0.222111 38.1188C-0.152608 37.3407 -0.0472328 36.4125 0.493142 35.7375L1.89095 33.9938C4.55064 30.6657 6.00002 26.5313 6.00002 22.275V19.1438C6.00002 12.0375 11.2031 6.14911 18 5.07005V3.3938C18 1.73724 19.3406 0.393799 21 0.393799C22.6594 0.393799 24 1.73724 24 3.3938ZM20.25 9.3938C14.8688 9.3938 10.5 13.7625 10.5 19.1438V22.275C10.5 26.7657 9.19877 31.1438 6.77908 34.8938H35.2219C32.8031 31.1438 31.5 26.7657 31.5 22.275V19.1438C31.5 13.7625 27.1313 9.3938 21.75 9.3938H20.25ZM27 42.3938C27 43.9032 26.3719 45.5157 25.2469 46.6407C24.1219 47.7657 22.5094 48.3938 21 48.3938C19.4063 48.3938 17.8781 47.7657 16.7531 46.6407C15.6281 45.5157 15 43.9032 15 42.3938H27Z",
    fill: "#611DED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7190_11523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 48,
    fill: "white",
    transform: "translate(0 0.393799)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.ff82705994a1a3a8f3e24d9dd72134a3.svg";
export { ForwardRef as ReactComponent };